import React from "react"

import auth from "@irati/auth"
import {
  Brand,
  Benefits,
  PromoMaterials,
  WelcomeEmail,
  Whitelist,
  Values,
  Teams,
  Invite
} from "@irati-web/tenantsetup/src/components/Steps"

export enum SetupSteps {
  BRAND = "onb:biz:set_brand",
  BENEFITS = "onb:biz:add_benefits",
  COMPANY_VALUES = "onb:biz:add_comp_vals",
  PROMO_MATS = "onb:biz:view_promo_mats",
  WHITELIST = "onb:biz:whitelist_domain",
  WELCOME_EMAIL = "onb:biz:set_welcome_email",
  CREATE_TEAMS = "onb:biz:create_teams",
  INVITE = "onb:biz:invite_people"
}

export enum SetupSections {
  CUSTOMISE = "CUSTOMISE",
  COMMUNICATE = "COMMUNICATE",
  INVITE = "INVITE"
}

export interface Step {
  order: number,
  title: string,
  subTitle: string,
  nestedPath: string,
  stepComponent: React.ReactNode,
  hideStep?: () => boolean
}

// A configuration to control the category of steps, this is fully controlled by the FE
export const sectionMapping = {
  [SetupSections.CUSTOMISE]: [SetupSteps.CREATE_TEAMS, SetupSteps.BRAND, SetupSteps.BENEFITS, SetupSteps.COMPANY_VALUES],
  [SetupSections.COMMUNICATE]: [SetupSteps.PROMO_MATS, SetupSteps.WHITELIST, SetupSteps.WELCOME_EMAIL],
  [SetupSections.INVITE]: [SetupSteps.INVITE]
}

// Additional step data managed by the FE
const stepDetails: {[key: string]: Step} = {
  [SetupSteps.CREATE_TEAMS]: {
    order: 1,
    title: "setup_tenant.steps.createTeams.title",
    subTitle: "setup_tenant.steps.createTeams.subTitle",
    nestedPath: "/teams",
    stepComponent: Teams
  },
  [SetupSteps.BRAND]: {
    order: 2,
    title: "setup_tenant.steps.brand.title",
    subTitle: "setup_tenant.steps.brand.subTitle",
    nestedPath: "/brand",
    stepComponent: Brand
  },
  [SetupSteps.BENEFITS]: {
    order: 3,
    title: "setup_tenant.steps.benefits.title",
    subTitle: "setup_tenant.steps.benefits.subTitle",
    nestedPath: "/benefits",
    stepComponent: Benefits
  },
  [SetupSteps.COMPANY_VALUES]: {
    order: 4,
    title: "setup_tenant.steps.values.title",
    subTitle: "setup_tenant.steps.values.subTitle",
    nestedPath: "/values",
    stepComponent: Values,
    hideStep: () => !auth.apps("recognition")
  },
  [SetupSteps.PROMO_MATS]: {
    order: 5,
    title: "setup_tenant.steps.promo.title",
    subTitle: "setup_tenant.steps.promo.subTitle",
    nestedPath: "/promo",
    stepComponent: PromoMaterials
  },
  [SetupSteps.WHITELIST]: {
    order: 6,
    title: "setup_tenant.steps.whitelist.title",
    subTitle: "setup_tenant.steps.whitelist.subTitle",
    nestedPath: "/whitelist",
    stepComponent: Whitelist
  },
  [SetupSteps.WELCOME_EMAIL]: {
    order: 7,
    title: "setup_tenant.steps.welcomeEmail.title",
    subTitle: "setup_tenant.steps.welcomeEmail.subTitle",
    subTitleMoreText: "setup_tenant.steps.welcomeEmail.subTitleMoreText",
    nestedPath: "/welcome-email",
    stepComponent: WelcomeEmail
  },
  [SetupSteps.INVITE]: {
    order: 8,
    title: "setup_tenant.steps.invite.title",
    subTitle: "setup_tenant.steps.invite.subTitle",
    subTitleMoreText: "setup_tenant.steps.invite.subTitleMoreText",
    nestedPath: "/invite-employees",
    stepComponent: Invite
  }
}

export default stepDetails
